import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PlatinumPage } from './platinum.page';

const routes: Routes = [
  {
    path: '',
    component: PlatinumPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PlatinumPageRoutingModule {}
